import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { FormTextField } from 'components/common/form/Form';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { addQuoteSchema } from 'validation/form/marketplace';
import { updateQuote } from 'store/slices/marketplace';
import { useMarketplaceDrawers } from 'hooks/useMarketplaceDrawers';
import { useAsyncDispatch } from 'hooks/useAsyncDispatch';

export const EditQuote = (props) => {
  const { close } = props;

  const dispatchAction = useAsyncDispatch();

  const { enqueueSnackbar } = useSnackbar();
  const { openDrawerQuoteDetails } = useMarketplaceDrawers();

  const loading = useSelector((state) => state.marketplace.newQuoteForm.loading);
  const selectedQuote = useSelector((state) => state.marketplace.selectedQuote);

  const methods = useForm({
    resolver: yupResolver(addQuoteSchema),
    defaultValues: {
      name: '',
    },
  });

  const handleSave = methods.handleSubmit((data) => {
    dispatchAction(updateQuote(data), {
      onSuccess: () => {
        enqueueSnackbar('Quote has been updated');
        close();
      },
    });
  });

  const handleCancel = () => {
    openDrawerQuoteDetails();
  };

  useEffect(() => {
    if (selectedQuote?.id) {
      methods.reset(selectedQuote);
    }
  }, [selectedQuote, methods]);

  return (
    <DrawerContent>
      <DrawerContent.Header title="Edit Quote" />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <FormProvider {...methods}>
            <FormTextField
              name="name"
              label="Quote Name"
              control={methods.control}
            />
          </FormProvider>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          submitButtonText="Save"
          submitButtonLoading={loading}
          submit={handleSave}
          close={handleCancel}
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
